import { useEffect } from 'react';

/**
 * Verrou de défilement du body, partagé entre le menu et la modale de recherche.
 *
 * Piège n°12 : la maquette remettait `document.body.style.overflow = ''` à
 * chaque fermeture. Si les deux panneaux se croisaient, le premier fermé
 * libérait le défilement alors que l'autre était encore ouvert. Un compteur de
 * verrous règle le problème.
 */
let lockCount = 0;
let previousOverflow = '';

const useScrollLock = (isLocked) => {
  useEffect(() => {
    if (!isLocked || typeof document === 'undefined') return undefined;

    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0) document.body.style.overflow = previousOverflow;
    };
  }, [isLocked]);
};

export default useScrollLock;
